import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";
import { AuthShell, ErrorBanner, linkCls } from "../components/AuthShell.js";

export function AuthCallbackPage() {
  const { finishOAuthCallback } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const code = params.get("code");
    const oauthError = params.get("error");
    const desc = params.get("error_description");

    if (oauthError) {
      setError(desc || oauthError);
      return;
    }
    if (!code) {
      setError("Missing authorization code.");
      return;
    }

    void (async () => {
      try {
        await finishOAuthCallback(code);
        navigate("/", { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : "Sign-in failed.");
      }
    })();
  }, [params, finishOAuthCallback, navigate]);

  return (
    <AuthShell title="Finishing sign-in" subtitle="One moment…">
      <ErrorBanner message={error} />
      {!error ? (
        <p className="text-center text-sm text-muted">Exchanging Google authorization…</p>
      ) : (
        <p className="pt-3 text-center text-sm text-muted">
          <Link to="/login" className={linkCls}>
            Back to login
          </Link>
        </p>
      )}
    </AuthShell>
  );
}
